import {Component, Inject, signal} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';

@Component({
  selector: 'app-tsa-log-dialog',
  templateUrl: './tsa-log-dialog.component.html',
  styleUrls: ['./tsa-log-dialog.component.scss'],
})
export class TsaLogDialogComponent {
  copied = signal(false);

  constructor(
    public dialogRef: DialogRef<void>,
    // The log content is fetched and existence-checked by the parent before this
    // dialog is opened (the button only appears when the log is present in the
    // preview bucket), so it is passed in ready-to-render.
    @Inject(DIALOG_DATA) public data: { filename: string, content: string },
  ) {}

  copy() {
    if (!navigator.clipboard?.writeText) return;
    navigator.clipboard.writeText(this.data.content).then(() => {
      this.copied.set(false);
      requestAnimationFrame(() => this.copied.set(true));
    });
  }
}
